module.exports = __webpack_public_path__ + "static/media/rinat.ac1ed860.jpg";